import { TabPanels } from "@headlessui/react-v2";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";

interface PanelsProps extends ComponentPropsWithoutRef<"div"> {
  children: ReactNode;
  className?: string;
}

export const Panels = ({ children, className = "", ...props }: PanelsProps) => (
  <TabPanels
    as="div"
    data-testid="tab-panels"
    className={classNames("size-full overflow-auto", className)}
    {...props}
  >
    {children}
  </TabPanels>
);

Panels.displayName = "Tab.Panels";
